import type { TIvFiscal, TRepoUiSpvGrid } from "@app/types/insider";

import { SPV_CONTRACTOR_MIRROR, SPV_RIGHT_TABS } from "@app/state/constants";
import { TCurrency } from "@app/types/insider";

import type { TBlueObj } from "@app/types/insider";

type TUIInvoiceCurrent = {
  currentGroupCFFID: number;
  currentRecord: TIvFiscal;
  otherInstanceCurrentRecord: TIvFiscal;
};

export const uiInvoiceCurrent: TBlueObj<TUIInvoiceCurrent> = {
  name: "uiInvoiceCurrent",
  initialState: {
    currentGroupCFFID: -1,
    currentRecord: {} as TIvFiscal,
    otherInstanceCurrentRecord: {} as TIvFiscal,
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
export enum EUIIMainSOT {
  FACTURI_FISCALE_EMISE = "FACTURI_FISCALE_EMISE",
  // FACTURI_FISCALE_PRIMITE = "FACTURI_FISCALE_PRIMITE",
  SPV_OVERALL = "SPV_OVERALL",
  SPV_FACTURI_TRIMISE = "SPV_FACTURI_TRIMISE",
  SPV_FACTURI_PRIMITE = "SPV_FACTURI_PRIMITE",
}
export type TUIInvoiceOverall = TRepoUiSpvGrid & {
  selectedCIF: string;
  currentCurrency: TCurrency;
  currentItem: string;
  includePrevious: boolean;
  mainSOT: EUIIMainSOT;
  trackCollectionFilter: string;
};

export const uiInvoiceOverall: TBlueObj<TUIInvoiceOverall> = {
  name: "uiInvoiceOverall",
  initialState: {
    colorized: false,
    currentCurrency: null,
    currentItem: "0",
    includePrevious: false,
    mainSOT: EUIIMainSOT.FACTURI_FISCALE_EMISE,
    selectedCIF: "",
    selectedContactID: -1,
    selectedCtorMirrorTab: SPV_CONTRACTOR_MIRROR.CTR_MIRR_TMP,
    selectedRightTab: SPV_RIGHT_TABS.FILE as
      | "FILES"
      | "CONTRACTOR"
      | "OPERATIONS",
    trackCollectionFilter: "ALL",
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};

export const uiCollectionCurrent: TBlueObj<{ iidInEdit: number }> = {
  name: "uiCollectionCurrent",
  initialState: {
    iidInEdit: -1,
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
